import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';

import dynamic from 'next/dynamic';
import { useAlgo } from '../hooks/useAlgo';
import Button from './Button';
import ConnectWalletMessage from './ConnectWalletMessage';
import Form from './Form';
import InputLabel from './InputLabel';
import Textarea from './Textarea';

const ConnectWalletButton = dynamic(() => import('./ConnectWalletButton'), {
  ssr: false,
});

const TheMassAddPage = () => {
  const { optInToAll, address } = useAlgo();
  const form = useForm({
    defaultValues: {
      assets: '',
    },
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);

  const assets = form.watch('assets');
  const assetIds = assets
    .split('\n')
    .filter((asset) => asset)
    .map((asset) => parseInt(asset.trim()));

  // chunk assets by 16
  const chunkedAssetIds = assetIds.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / 16);
    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []; // start a new chunk
    }
    resultArray[chunkIndex].push(item);
    return resultArray;
  }, []);
  const totalPages = chunkedAssetIds.length;

  const handleSubmit = async (args) => {
    if (loading) return;
    if (!args.assets) {
      toast.error('assets is required');
      return;
    }

    setLoading(true);

    try {
      // make an array of asset ids
      const response = await optInToAll(chunkedAssetIds[page]);
      toast.success(`Successfully opted-in to ${chunkedAssetIds[page].length} assets`);

      if (page < totalPages - 1) {
        setPage(page + 1);
        return;
      }
      form.reset();
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || error.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  if (!address) {
    return (
      <div className='flex justify-center mt-12 md:mt-20'>
        <ConnectWalletMessage />
      </div>
    );
  }

  return (
    <div className='mt-10'>
      <Form onSubmit={handleSubmit} form={form} className='flex items-center flex-col justify-center gap-5'>
        <div className='flex gap-5'>
          <div>
            <InputLabel>Assets</InputLabel>
            <Textarea rows='7' name='assets' required fullWidth />
          </div>
        </div>
        <div>
          <p className='text-gray-500 text-lg font-bold'>Assets: {assetIds.length}</p>
        </div>
        <div>
          <Button loading={loading} type='submit'>
            Mass Add
          </Button>
        </div>
        {totalPages > 1 && (
          <div>
            <p className='text-gray-500 text-lg font-bold'>Signatures needed: {totalPages - page}</p>
          </div>
        )}
      </Form>
    </div>
  );
};

export default TheMassAddPage;
